import type { DealFixedRateLoanData, DealFloatingRateLoanData } from '@src/types/OTC';
import { getOtcDealLoanAmountDisplayValue } from '@src/utils/OTC/otcDealDisplayUtils';
import type { OTCFixedRateLoanSecurity, OTCFloatingRateLoanSecurity } from '@talos/kyoko';
import { InlineFormattedNumber } from '@talos/kyoko';

interface LoanAmountDisplayProps {
  instrumentData: DealFixedRateLoanData | DealFloatingRateLoanData;
  dealSecurity: OTCFixedRateLoanSecurity | OTCFloatingRateLoanSecurity;
}

export const LoanAmountDisplay = ({ instrumentData, dealSecurity }: LoanAmountDisplayProps) => {
  const { value, currency } = getOtcDealLoanAmountDisplayValue(instrumentData, dealSecurity);
  return (
    <InlineFormattedNumber
      data-testid="instrument-inspector-section-field-value"
      number={value}
      currency={currency}
      background="backgroundBlotterTableRowHover"
      showDashIfEmpty
    />
  );
};
